import classNames from 'classnames'
import { ElementType, HTMLAttributes, ReactNode, createElement, forwardRef } from 'react'

import styles from './text.module.css'

export type LegacyTextVariant =
    | 'title'
    | 'sectionTitle'
    | 'body'
    | 'bodyMuted'
    | 'caption'
    | 'link'
    | 'button'

export interface LegacyTextProps extends HTMLAttributes<HTMLElement> {
    as?: ElementType
    children: ReactNode
    variant?: LegacyTextVariant
}

const variantClassName: Record<LegacyTextVariant, string> = {
    title: styles.title,
    sectionTitle: styles.sectionTitle,
    body: styles.body,
    bodyMuted: styles.bodyMuted,
    caption: styles.caption,
    link: styles.link,
    button: styles.button,
}

export const Text = forwardRef<HTMLElement, LegacyTextProps>(function Text({
    as = 'p',
    children,
    className,
    variant = 'body',
    ...rest
}, ref) {
    return createElement(
        as,
        {
            className: classNames(styles.text, variantClassName[variant], className),
            ref,
            ...rest,
        },
        children,
    )
})
